import styled from 'styled-components'

export const Container = styled.ol.attrs((props: { isCentered?: boolean }) => {
  return {
    className: `d-flex pt-3 align-items-center flex-wrap container ${
      props.isCentered ? 'justify-content-center' : 'justify-content-start'
    }`,
  }
})<{ isInError?: boolean; isCentered?: boolean }>`
  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    padding-left: 0 !important;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm.max}) {
    background-color: ${({ theme }) => theme.palette.white};
    margin-left: 0;
  }
`
export const BreadcrumbListItem = styled.li.attrs({
  className: 'd-none d-md-flex align-items-center',
})`
  &:last-child {
    opacity: 0.4;
    pointer-events: none;
    & a {
      cursor: default;
    }
  }

  // display only the previous item on mobile
  @media (max-width: ${({ theme }) => theme.breakpoints.sm.max}) {
    &:nth-last-child(2) {
      display: flex !important;
      flex-direction: row-reverse;
      padding: 1rem 0;
      & svg {
        transform: rotate(180deg);
      }
    }
  }

  & svg {
    fill: ${({ theme }) => theme.palette.greyTitle};
    margin-left: 0.5rem;
  }
`

export const BreadcrumbLink = styled.a.attrs({
  className: 'd-flex align-items-center mr-2',
})`
  font-size: 1.4rem;
  cursor: pointer;
`

export const MainContainer = styled.div.attrs({
  className: 'd-flex align-items-center',
})`
  @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
    margin-top: 1.5rem;
  }
`
